function optimizelyService ($window) {
    return $window.optimizely;
}

optimizelyService.$inject = [
    '$window'
];

export default optimizelyService;
